import { render, staticRenderFns } from "./MonitorScoreExamTable.vue?vue&type=template&id=e70e60a2&"
import script from "./MonitorScoreExamTable.vue?vue&type=script&lang=js&"
export * from "./MonitorScoreExamTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports